<template>
  <div>
    <el-dialog :title="text"
               :visible.sync="dialogVisible"
               :close-on-click-modal="false"
               :append-to-body="true"
               width="1200rem"
               :before-close="handleClose">
      <el-table :data="tableData"
                style="width: 100%">
        <el-table-column prop="lecture_name"
                         align="left"
                         label="讲义名称" />
        <el-table-column width="200"
                         align="center"
                         label="操作">
          <template slot-scope="{row}">
            <el-button type="primary"
                       @click="showVideo(row)">
              查看讲义
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>

import { videoList } from '@/api/knowledgeVideo.js'
import { checkpointVideo, knowledgeVideo } from '@/api/checkpoint.js'
export default {
  data () {
    return {
      form: {},
      tableData: [],
      dialogVisible: false,
      text: '',
  
      filename: '',
    }
  },
 
  methods: {
    handleClose () {
      this.dialogVisible = false
    },
    showVideo (row) {
      window.open(row.lecture_file, '_blank')
    },
    async initList (data) {
        this.tableData = data
    }
    // async save () {
    //   await collect(this.form)
    //   this.handleClose()
    //   this.$message.success('收藏成功，可前往错题本查看')
    // }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  font-size: 20rem;
  font-weight: bold;
  color: black;
  text-align: center;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: white;
  background: #cccccc;
  border-radius: 50%;
  padding: 4rem;
}

::v-deep .el-dialog {
  border-radius: 20rem;
  // height: 600rem;
  margin-top: 198rem !important;
}

::v-deep .el-table th,
.el-table tr {
  background: #f6f6f6;
}
::v-deep .cell {
  text-indent: 60rem;
}
</style>